
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import NewPagination from '@/common/new-components/NewPagination/index.vue'
import NewLimit from '@/common/new-components/NewLimit/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import List from '@/common/components/UI/List/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// module components
import DeliveryCompaniesListItem from '@/modules/DeliveryCompaniesModule/components/DeliveryCompaniesListItem/index.vue'

// realisations
import { deliveryCompanies } from '@/core/realisations/delivery-companies.realisation'

// types
import { DeliveryCompanyT } from '@/core/types/delivery-companies.types'

// composable
import useAccount from '@/common/composable/useAccount'
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        PageTitle,
        Loader,
        NewPagination,
        NewLimit,
        FailedFetch,
        List,
        DeliveryCompaniesListItem,
        TheButton,
    },
    setup() {
        const notifications = useNotifications()
        const { havePermissions } = useAccount()

        const state = reactive({
            limit: 50,
            companies: {
                is_loading: false,
                is_failed: false,
                list: [] as DeliveryCompanyT[],
                pagination: {
                    current_page: 1,
                    total_pages: 1,
                    total_items: 0,
                },
            },
        })

        const loadCompanies = async (page: number) => {
            state.companies.pagination.current_page = page

            try {
                state.companies.is_loading = true

                const response = await deliveryCompanies.getCompanies({
                    page: state.companies.pagination.current_page,
                    limit: state.limit,
                })

                state.companies.list = response.data
                state.companies.pagination.total_pages = response.meta.last_page
                state.companies.pagination.total_items = response.meta.total

                state.companies.is_failed = false
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении списка компаний произошла ошибка',
                })
                state.companies.is_failed = true
            } finally {
                state.companies.is_loading = false
            }
        }

        onBeforeMount(() => {
            loadCompanies(1)
        })

        const onLimitChange = (limit: number) => {
            state.limit = limit
            loadCompanies(state.companies.pagination.current_page)
        }

        const onChangePage = (page: number) => {
            loadCompanies(page)
        }

        return {
            state,
            loadCompanies,
            onLimitChange,
            onChangePage,
            havePermissions,
        }
    },
})
